import { Component, ErrorInfo, ReactNode } from "react"

interface ErrorBoundaryProps {
	onError: (error: Error) => void
	children: ReactNode
}

export class ErrorBoundary extends Component<ErrorBoundaryProps> {
	componentDidMount() {
		window.addEventListener(
			"unhandledrejection",
			this.handleUnhandledRejection,
		)
	}

	componentWillUnmount() {
		window.removeEventListener(
			"unhandledrejection",
			this.handleUnhandledRejection,
		)
	}

	componentDidCatch(error: Error, _errorInfo: ErrorInfo) {
		this.props.onError(error)
	}

	handleUnhandledRejection = (event: PromiseRejectionEvent) => {
		event.preventDefault()

		const error = event.reason
		this.props.onError(
			error instanceof Error ? error : new Error(String(error)),
		)
	}

	render() {
		return this.props.children
	}
}
